export default {
  "translation": {
    "Inspection": "Inspektion",
  }
}
